export default function classNames(...classes: string[]) {
  return classes.join(" ");
}